import React from 'react';
import styles from './Layouts.module.scss';

export const CenteredWidthAndHeightLayout = ({ children }) => (
  <div className={styles.centeredWidthAndHeightLayout}>{children}</div>
);

export const CenteredWidthLayout = ({ children }) => (
  <div className={styles.centeredWidthLayout}>{children}</div>
);

export const MobilePaddingLayout = ({ children }) => (
  <div className={styles.mobilePaddingLayout}>{children}</div>
);

export const Container = ({ children }) => (
  <div style={{ position: 'relative' }} className="container-fluid">
    {children}
  </div>
);
